/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import { FourColGrid, PageIntroductionCard } from "@quintype/arrow";
import React from "react";
import PropTypes from "prop-types";

export const PurchasedStoriesComponent = ({ collection = {}, config = {} }) => {
  const pageDescription =
    "View all the articles you've purchased on this page. Explore your collections and enjoy reading!";
  return (
    <>
      <PageIntroductionCard
        config={{ pageTitle: "Purchased Stories", pageDescription: pageDescription, theme: "#fff" }}
      />
      <FourColGrid collection={collection} config={config} />
    </>
  );
};

PurchasedStoriesComponent.propTypes = {
  collection: PropTypes.object,
  config: PropTypes.object,
};
